import gql from 'graphql-tag'

export default gql`
  query getCheckout($cartId: UUID!, $currency: String!) {
    checkout(cartId: $cartId, currency: $currency) {
      ... on Checkout {
        payment {
          clientSecret
          id
        }
        cart {
          ... on Cart {
            id
            cartAmount
            currency
            items {
              id
              sku
              salesPrice
              category
              name
              image {
                url
                description
              }
              ... on GenericCartItem {
                quantity
                description
              }
              ... on GiftCardCartItem {
                value
                recipientDetails {
                  recipientName
                  message
                  ... on VirtualRecipientDetails {
                    recipientEmail
                    recipientMobileNumber
                    senderName
                    deliveryDate
                    deliveryMethod
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`
